/*
 BAKER HUGHES COMPANY CONFIDENTIAL

* Unpublished work copyright 2025 Baker Hughes Company.  All rights reserved.
* This computer code is proprietary and highly confidential to Baker Hughes Company
* and/or its affiliate(s). It may not be used, disclosed, modified, transferred,
* or reproduced without prior written consent, and must be returned on demand.
*/
import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
} from '@material-ui/core';

interface CookieConsentModalProps {
  open: boolean;
  onAccept: () => void;
}

export const CookieConsentModal: React.FC<CookieConsentModalProps> = ({
  open,
  onAccept,
}) => {
  return (
    <Dialog open={open} disableBackdropClick disableEscapeKeyDown maxWidth="sm" fullWidth>
      <DialogTitle>
        <Typography variant="h5" component="div">
          Privacy & Cookie Notice
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Typography variant="body1" paragraph style={{ fontSize: '16px' }}>
          We use cookies on our website. All of these are strictly necessary
            cookies (i.e. required to enable core functionalities of the
          website) and have to be placed on your device.
        </Typography>
        <Box component="ul" style={{ listStyle: 'none', padding: 0, margin: 0 }}>
          <li style={{ display: 'flex', marginBottom: '8px' }}>
            <Typography variant="body1" style={{ minWidth: '120px', fontSize: '16px' }}>
              Name
            </Typography>
            <Typography variant="body1" style={{ fontSize: '16px' }}>
              local.cookie & appId
            </Typography>
          </li>
          <li style={{ display: 'flex', marginBottom: '8px' }}>
            <Typography variant="body1" style={{ minWidth: '120px', fontSize: '16px' }}>
              Host
            </Typography>
            <Typography variant="body1" style={{ fontSize: '16px' }}>
              {window.location.host}
            </Typography>
          </li>
           <li style={{ display: 'flex', marginBottom: '8px' }}>
            <Typography variant="body1" style={{  minWidth: '120px', fontSize: '16px' }}>
              Duration
            </Typography>
            <Typography variant="body1" style={{ fontSize: '16px' }}>
              session
            </Typography>
          </li>
           <li style={{ display: 'flex', marginBottom: '8px' }}>
            <Typography variant="body1" style={{ minWidth: '120px', fontSize: '16px' }}>
              Description
            </Typography>
            <Typography variant="body1" style={{ fontSize: '16px' }}>
              These cookies are general purpose session cookies & are strictly
              necessary for operation of our application
            </Typography>
          </li>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onAccept} color="primary" variant="contained">
          Continue
        </Button>
      </DialogActions>
    </Dialog>
  );
};